/**
 * @generated SignedSource<<3dbc1c9c64a9fedc2aa4be05f4838a00>>
 * @relayHash 410af1af4a2f50daba88ef0f632db253
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7fd1dfa367235bcf8a154ab7e8659f2c5171402632af4ba7fc1f3e51acd8e4a2

import type { ConcreteRequest, Query } from 'relay-runtime';
export type KnowledgeBaseArticleSearchSortByKey = "LAST_MODIFIED" | "TITLE" | "%future added value";
export type KnowledgeBaseArticleSearchSortOrder = "ASC" | "DESC" | "%future added value";
export type KnowledgeBaseArticleSearchInput = {
  articleContainers?: ReadonlyArray<string> | null | undefined;
  cloudId: string;
  cursor?: string | null | undefined;
  limit?: number | null | undefined;
  projectId?: string | null | undefined;
  searchQuery?: string | null | undefined;
  sortByKey?: KnowledgeBaseArticleSearchSortByKey | null | undefined;
  sortOrder?: KnowledgeBaseArticleSearchSortOrder | null | undefined;
};
export type viewArticlesTableQuery$variables = {
  searchInput?: KnowledgeBaseArticleSearchInput | null | undefined;
};
export type viewArticlesTableQuery$data = {
  readonly knowledgeBase_searchArticles: {
    readonly __typename: "KnowledgeBaseCrossSiteSearchConnection";
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly lastModified: string | null | undefined;
      readonly spaceName: string | null | undefined;
      readonly spaceUrl: string | null | undefined;
      readonly title: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | {
    readonly __typename: "QueryError";
    readonly message: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type viewArticlesTableQuery = {
  response: viewArticlesTableQuery$data;
  variables: viewArticlesTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchInput"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "searchInput",
        "variableName": "searchInput"
      }
    ],
    "kind": "LinkedField",
    "name": "knowledgeBase_searchArticles",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "concreteType": "KnowledgeBaseCrossSiteArticle",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "lastModified"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "spaceName"
              },
              {
                "kind": "ScalarField",
                "name": "spaceUrl"
              },
              {
                "kind": "ScalarField",
                "name": "title"
              },
              {
                "kind": "ScalarField",
                "name": "url"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
              },
              {
                "kind": "ScalarField",
                "name": "startCursor"
              }
            ]
          }
        ],
        "type": "KnowledgeBaseCrossSiteSearchConnection"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ],
        "type": "QueryError"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "viewArticlesTableQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "viewArticlesTableQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7fd1dfa367235bcf8a154ab7e8659f2c5171402632af4ba7fc1f3e51acd8e4a2",
    "metadata": {},
    "name": "viewArticlesTableQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9893167b842c0f154647ea61aba8a01f";

export default node;
